// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { rejectLabResult, saveLabResult } from 'services/lab_result/result';
import { Button, Col, Form, Modal, Row, Input } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
// import NotifModal from 'modules/main/lab_result/editing_result/modal';
import Message from 'shared_components/message';
import { ExclamationCircleOutlined } from "@ant-design/icons";

// CSS
import './actions.css';

const { TextArea } = Input;

class Actions extends React.Component {
	constructor(props) {
		super(props);

		this.timer = null;
		this.countdownTime = 2500;
		this.state = {
			// isDisplayModal: false,
			isApproving: false,
			// isSaving: false
			approvedButtonDisable: true,
			modalAction: false,
		};

		this.formRef = React.createRef();
	}

	componentWillUnmount() {
		// clearTimeout(this.timer);
	}

	onClickSave = async () => {
		const { getLabResultFormValues, onSaveSuccess, resultStatus, onPrint } = this.props;
		const labResultFormValues = await getLabResultFormValues();
		const userSession = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		// console.log('labResultFormValues=>', labResultFormValues);

		if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
			this.setState({ isSaving: true }, async () => {
				const savedResults = await saveLabResult({
					results: labResultFormValues.form.results,
					remarks: labResultFormValues.remarks.value ? labResultFormValues.remarks.value : '',
					userID: userSession.userID,
					action: 'Saved',
				});

				this.setState({ isSaving: false }, () => {
					if (savedResults) {
						onSaveSuccess();

						Message.success({ message: `Results successfully saved.` });

						// if (resultStatus === 'Checked-In')
						// {
						// 	onPrint(); //will print if approved
						// }
					}
				});
			});
		}
	};

	onClickApprove = async () => {
		console.log('onclickapprove');
		const {
			getLabResultFormValues,
			onSaveSuccess,
			resultStatus,
			onPrint,
			specimenStatusID,
		} = this.props;
		const labResultFormValues = await getLabResultFormValues();
		const userSession = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
		const action = specimenStatusID === 3 ? 'Unapproved' : 'Approved';

		if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
			this.setState({ isApproving: true }, async () => {
				const savedResults = await saveLabResult({
					results: labResultFormValues.form.results,
					remarks: labResultFormValues.remarks.value ? labResultFormValues.remarks.value : '',
					userID: userSession.userID,
					action,
				});

				this.setState({ isApproving: false }, () => {
					if (savedResults) {
						onSaveSuccess();
						if (action === 'Approved') {
							Message.success({ message: `Results successfully approved.` });
							onPrint(); //will print if approved
						} else {
							Message.success({ message: `Results have been disapproved.` });
						}
					}
				});
			});
		}
	};

	onConfirmReject = async (reason) => {
		console.log('onConfirmReject', reason.reason);
		const { getLabResultFormValues, onSaveSuccess, headerDetails } = this.props;

		const labResultFormValues = await getLabResultFormValues();
		const userSession = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
			this.setState({ isRejecting: true }, async () => {
				const rejectPayload = {
					patientID: headerDetails.patientInfo.patientID,
					requestID: headerDetails.patientInfo.requestID,
					sampleSpecimenID: headerDetails.sampleSpecimenID,
					sectionID: 0,
					specimenID: 0,
					checkinLocation: "",
					remarks: reason.reason,
					specimenStatusID: 9,
					userID: userSession.userID,
				}

				this.setState({ modalAction: false })
				const rejectResult = await rejectLabResult(rejectPayload)

				this.setState({ isApproving: false }, () => {
					if (rejectResult) {
						onSaveSuccess();
						Message.success({ message: `Results Rejected.` });
					}
				});
			});
		}
	};

	onClickPreview = async () => {
		console.log('onclickpreview');
		const {
			getLabResultFormValues,
			onSaveSuccess,
			resultStatus,
			onPrint,
			isResultsTouched,
		} = this.props;
		const labResultFormValues = await getLabResultFormValues();
		const userSession = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		if (!labResultFormValues.form.hasError && !labResultFormValues.remarks.hasError) {
			this.setState({ isSaving: true }, async () => {
				const savedResults = await saveLabResult({
					results: labResultFormValues.form.results,
					remarks: labResultFormValues.remarks.value ? labResultFormValues.remarks.value : '',
					userID: userSession.userID,
					action: 'Saved',
				});

				this.setState({ isSaving: false }, () => {
					if (savedResults) {
						onSaveSuccess();

						if (isResultsTouched) {
							Message.success({ message: `Results successfully saved.` });
						}
						onPrint();
					}
				});
			});
		}
	};

	render() {
		const { isApproving, isSaving, isRejecting, modalAction } = this.state;
		const { onPrint, resultStatus, isResultsTouched, specimenStatusID, results } = this.props;
		console.log('🚀 ~ file: index.js:130 ~ Actions ~ render ~ specimenStatusID:', specimenStatusID);

		// const hasEmptyReleasedResult = Array.isArray(results.resultValues) && results.resultValues.some(item => item.releasedResult === '');
		// console.log("🚀 ~ file: index.js:140 ~ Actions ~ render ~ hasEmptyReleasedResult:", hasEmptyReleasedResult)

		const disableTrue = specimenStatusID === 3 ? true : false;

		return (
			<div className="lab-res-edit-action-container">
			<Modal
					open={modalAction}
					onOk={this.onConfirmReject}
					onCancel={()=> this.setState({ modalAction: false })}
					footer={[null]}
				>
					<div>
						<Form layout="vertical" onFinish={this.onConfirmReject}>
							<Row>
								<Col span={24}>
								<Form.Item label="REASON FOR REJECTION" name="reason" rules={[{ required: true }]}>
									<TextArea rows={4} placeholder="Input Text" />
								</Form.Item>
								</Col>
							</Row>
							<Row>
								<Col span={24}>
									<Form.Item shouldUpdate style={{ marginBottom: 0 }}>
										{({ getFieldsValue }) => {
											const { reason } = getFieldsValue();
											const disabled = !reason;
						
											return (
												<div className="buttons" style={{ float: "right" }}>
												<Button type="primary" style={{ width: 120, marginRight: 5, }} onClick={()=> this.setState({ modalAction: false })}>
													CANCEL
												</Button>
												<Button type="primary" htmlType="submit" style={{ width: 120 }} disabled={disabled}>
													OK
												</Button>
												</div>
											);
										}}
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</Modal>

				{specimenStatusID === 9 ? <></> :
					<Button
						loading={isRejecting}
						shape="round"
						type="primary"
						onClick={()=>this.setState({ modalAction: true })}
						className="action-buttons"
						disabled={false}
					>
						REJECT
					</Button>
				}
				{specimenStatusID === 3 ? (
					<Button
						loading={isApproving}
						shape="round"
						type="primary"
						onClick={this.onClickApprove}
						className="action-buttons"
						disabled={!disableTrue}
					>
						{specimenStatusID === 3 ? 'DISAPPROVE' : 'APPROVE'}
					</Button>
				) : (
					<></>
				)}

				{specimenStatusID === 5 ? (
					<Button
						shape="round"
						type="primary"
						onClick={this.onClickPreview}
						className="action-buttons"
						disabled={true}
					>
						APPROVE
					</Button>
				) : (
					<></>
				)}

				{specimenStatusID === 1 || specimenStatusID === 7 ? (
					<Button
						loading={isApproving}
						shape="round"
						type="primary"
						onClick={this.onClickApprove}
						className="action-buttons"
						disabled={!isResultsTouched}
					>
						{specimenStatusID === 3 ? 'DISAPPROVE' : 'APPROVE'}
					</Button>
				) : (
					<></>
				)}

				{specimenStatusID === 4 ? (
					<Button
						loading={isApproving}
						shape="round"
						type="primary"
						onClick={this.onClickApprove}
						className="action-buttons"
						disabled={false}
					>
						{specimenStatusID === 3 ? 'DISAPPROVE' : 'APPROVE'}
					</Button>
				) : (
					<></>
				)}

				{specimenStatusID === 2 ? (
					<Button
						loading={isApproving}
						shape="round"
						type="primary"
						onClick={this.onClickApprove}
						className="action-buttons"
						disabled={false}
					>
						{specimenStatusID === 3 ? 'DISAPPROVE' : 'APPROVE'}
					</Button>
				) : (
					<></>
				)}

				{specimenStatusID !== 6 ? (
					<Button
						// loading={isSaving}
						shape="round"
						type="primary"
						onClick={this.onClickSave}
						disabled={
							specimenStatusID === 5 || specimenStatusID === 3 || isApproving || !isResultsTouched
						}
						className="action-buttons"
					>
						SAVE
					</Button>
				) : (
					<>
					<Button
						loading={isApproving}
						shape="round"
						type="primary"
						onClick={this.onClickApprove}
						className="action-buttons"
						disabled={false}
					>
						APPROVE
					</Button>
					<Button
						// loading={isSaving}
						shape="round"
						type="primary"
						onClick={this.onClickSave}
						className="action-buttons"
						disabled={false}
					>
						SAVE
					</Button>
					</>
				)}

				{specimenStatusID === 1 || specimenStatusID === 7 ? (
					<Button
						shape="round"
						type="primary"
						onClick={this.onClickPreview}
						className="action-buttons"
						disabled={specimenStatusID !== 3 && specimenStatusID !== 2 && !isResultsTouched}
					>
						PRINT PREVIEW
					</Button>
				) : specimenStatusID === 2 ? (
					<Button
						shape="round"
						type="primary"
						onClick={this.onClickPreview}
						className="action-buttons"
						// disabled={!isResultsTouched && (resultStatus !== 'Approved' && resultStatus !== 'Saved')}
						disabled={specimenStatusID === 5}
					>
						PRINT PREVIEW
					</Button>
				) : specimenStatusID === 3 ? (
					<Button
						shape="round"
						type="primary"
						onClick={onPrint}
						className="action-buttons"
						// disabled={!isResultsTouched && (resultStatus !== 'Approved' && resultStatus !== 'Saved')}
						disabled={specimenStatusID === 5}
					>
						PRINT PREVIEW
					</Button>
				): specimenStatusID === 6 ? (
					<Button
						shape="round"
						type="primary"
						onClick={onPrint}
						className="action-buttons"
						disabled={false}
					>
						PRINT PREVIEW
					</Button>
				) : (
					<Button
						shape="round"
						type="primary"
						onClick={this.onClickPreview}
						className="action-buttons"
						disabled={
							specimenStatusID === 5 ||
							specimenStatusID === 7 ||
							specimenStatusID === 1 ||
							!isResultsTouched
						}
					>
						PRINT PREVIEW
					</Button>
				)}

				{/* <NotifModal isDisplay={isDisplayModal} /> */}
			</div>
		);
	}
}

Actions.propTypes = {
	getLabResultFormValues: PropTypes.func.isRequired,
	onSaveSuccess: PropTypes.func.isRequired,
	onPrint: PropTypes.func.isRequired,
	resultStatus: PropTypes.string.isRequired,
	isResultsTouched: PropTypes.bool.isRequired,
	approvedButtonDisable: PropTypes.bool,
	specimenStatusID: PropTypes.string.isRequired,
};

export default Actions;
